import { Box, Button } from "@material-ui/core"
import { useEffect, useState } from "react"
import { TextFieldSaurus } from "views/components/controles/inputs"
import { DialogSaurus } from "views/components/dialog/dialog-saurus/dialog-saurus"
import { OkIcon } from "views/components/icons"

export interface DialogCarregarTemplateHtmlProps {
    onSubmit: (url: string) => void
    open: boolean
    setOpen: (open: boolean) => void
}

export const DialogCarregarTemplateHtml = ({ onSubmit, open, setOpen }: DialogCarregarTemplateHtmlProps) => {
    const [value, setValue] = useState<string>('')

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        onSubmit(value)
        setOpen(false)
    }
    useEffect(() => {
        setValue('')
    }, [open])
    return (
        <DialogSaurus
            titulo="Insira a URL da Imagem"
            aberto={open}
            isButtonTitleClose
            tamanho="sm"
            handleClickClose={() => setOpen(false)}
        >
            <Box component="form" onSubmit={handleSubmit} display="flex" flexDirection="column" gridGap={16}>
                <TextFieldSaurus tipo="TEXTO" label="URL da Imagem (2268x1080 em Pixel)" value={value} onChange={e => setValue(e.target.value)} />
                <Button color="primary" type="submit" variant="contained">
                    <OkIcon tipo="BUTTON_PRIMARY" />
                    Confirmar
                </Button>
            </Box>
        </DialogSaurus>
    )
}